import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
import Vuelidate from 'vuelidate'
import VeeValidate from 'vee-validate'
import VueMoment from 'vue-moment'
import firebase from 'firebase'
import VueScrollTo from 'vue-scrollto'

import VueLodash from 'vue-lodash'
import lodash from 'lodash'

import LogistyConsts from './LogistyConsts'

import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

const moment = require('moment')
require('moment/locale/th')

Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.use(VueCookies)
VueCookies.config('7d')
Vue.use(Vuelidate)
Vue.use(VeeValidate)
Vue.use(VueMoment, { moment })
Vue.use(VueFormWizard)
Vue.use(LogistyConsts)

Vue.use(VueLodash, { name: 'custom', lodash: lodash })

Vue.use(VueScrollTo)

Window.Event = new Vue()

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID
}

firebase.initializeApp(firebaseConfig)

if (window.$cookies.isKey('token')) {
  store.dispatch('checkCompanyStatus')
    .then(function () {
      new Vue({
        router,
        store,
        render: h => h(App)
      }).$mount('#app')
    })
} else {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}
